import React from 'react';
import { MenuItem } from '@material-ui/core';

export const getSelectOptions = (data) => {
    const options = data.map((option) => {
        return (<MenuItem key={option.value} value={option.value}>{option.display}</MenuItem>)
    });

    return options;
}